import type {Reducer} from 'react'
import {useEffect, useReducer} from 'react'

export function createPersistedReducer<State>(key: string) {
    if (typeof window === 'undefined') {
        return useReducer
    }

    const getState = (initialState: State) => {
        const json = localStorage.getItem(key)

        if (json === null) {
            return typeof initialState === 'function' ? initialState() : initialState
        }

        return JSON.parse(json)
    }

    const setState = (state: State) => localStorage.setItem(key, JSON.stringify(state))

    return function (reducer: Reducer<State, any>, initialState: State) {
        const [state, dispatch] = useReducer(reducer, getState(initialState))

        useEffect(() => {
            setState(state)
        }, [state])

        return [state, dispatch] as const
    }
}

export default createPersistedReducer
